import React, { ReactElement } from 'react';
import style from './index.module.css';

export interface StarProps {
  marked: boolean;
  starId: number;
}

const Star = (props: StarProps): ReactElement => {
  const { starId, marked } = props;
  return (
    <span
      star-id={starId}
      className={`${marked ? style.activeStar : ''} ${style.star}`}
      role="button"
    ></span>
  );
};

export default React.memo(Star);
